import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogService } from '../../../shared/services/dialog.service';
import { BreezeService } from '../../../shared/services/breeze.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HelperService } from '../../../shared/services/helper.service';
import { ErrorService } from '../../../shared/services/error.service';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
@Component({
    selector: 'app-forgot-password-dialog',
    templateUrl: './forgot-password-dialog.component.html',
    styleUrls: ['./forgot-password-dialog.component.scss'],
    imports: [FormsModule, ReactiveFormsModule]
})
export class ForgotPasswordDialogComponent {
  private emailRegEx =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  email = new FormControl('', [
    Validators.required,
    Validators.pattern(this.emailRegEx),
  ]);
  errorMessage: any;
  constructor(
    private breezeService: BreezeService,
    private errorService: ErrorService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.errorService.getErrorListener().subscribe((errorMessage) => {
      this.errorMessage = errorMessage;
    });
  }

  onForgotPassword() {
    // Handles request
    if (this.email.invalid) {
      this.email.markAllAsTouched();
      return;
    }
    this.breezeService.forgoPassword(this.email.getRawValue() || '');
  }
}
